export default function Footer() {
  return (
    <footer className="w-full bg-melon-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr_1fr] gap-10">
          <div>
            <div className="flex items-center gap-2 font-display">
              <span className="w-9 h-9 rounded-full bg-gradient-to-br from-melon-500 to-melon-700 flex items-center justify-center text-lg">
                <i className="ri-vip-crown-fill"></i>
              </span>
              <span className="font-bold text-2xl">吃瓜大赛</span>
            </div>
            <p className="mt-4 text-sm text-white/70 leading-relaxed max-w-sm">
              全网人气投票打榜聚集地，实时人气排行榜与热门PK助力实时更新。
              为每一位值得被看见的选手加油，让热爱被更多人见证。
            </p>
            <div className="mt-5 flex gap-2">
              {['ri-wechat-fill', 'ri-weibo-fill', 'ri-douban-fill', 'ri-bilibili-fill'].map((i, idx) => (
                <a
                  key={idx}
                  href="#home"
                  aria-label="社交媒体入口"
                  className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-lg transition-colors"
                >
                  <i className={i}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold tracking-widest text-white/90 mb-4">活动导航</h4>
            <ul className="space-y-2.5 text-sm text-white/70">
              {[
                ['#ranking', '实时人气排行榜'],
                ['#pk', '热门人气PK'],
                ['#shows', '本季参赛看点'],
                ['#guide', '打榜助力指南'],
                ['#faq', '常见问题答疑'],
              ].map(([href, label]) => (
                <li key={href}>
                  <a href={href} className="hover:text-white transition-colors">{label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold tracking-widest text-white/90 mb-4">联系与帮助</h4>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li className="flex items-center gap-2"><i className="ri-mail-line"></i>support@chigua-party.example.com</li>
              <li className="flex items-center gap-2"><i className="ri-time-line"></i>在线客服 9:00 - 21:00</li>
              <li className="flex items-center gap-2"><i className="ri-shield-check-line"></i>免费参与 · 谨防私下转账</li>
            </ul>
            <a
              href="#ranking"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap px-6 py-3 text-sm font-bold rounded-full bg-gradient-to-r from-sun-400 to-sun-500 text-ink hover:brightness-105 transition-all"
            >
              <i className="ri-fire-fill"></i>现在去打榜
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© 2026 吃瓜大赛 · 吃瓜大赛投票打榜人气排行榜 &nbsp;·&nbsp; 全民娱乐互动，仅作内容展示</p>
          <p>让热爱被看见 · All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}